import { Stack } from '@mui/material';

import MyTaskMyTaskFilter from './MyTaskMyTaskFilter';
import MyTasksClearButton from './MyTasksClearButton';
import MyTasksSearchInput from './MyTasksSearchInput';
import MyTasksDateRangeFilter from './MyTasksDateRangeFilter';
import TeamsFilter from './TeamsFilter';
import ResponsibleFilter from './ResponsibleFilter';

const MyTasksFilters = () => {
    return (
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={3}>
            <MyTasksDateRangeFilter />
            <MyTasksSearchInput />
            <TeamsFilter />
            <ResponsibleFilter />
            <MyTaskMyTaskFilter />
            <MyTasksClearButton />
        </Stack>
    );
};

export default MyTasksFilters;
